<template>
  <div class="p_t">
    <TopHead title="教学展示详情"></TopHead>
    <div class="header">
      <h2 class="t_a">{{info.title}}</h2>

    </div>
    <div class="a_top">
      <div class="f_content" v-html="info.contentInfo"></div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        contentId:0,
        info:{}
      };
    },
    created() {
      this.contentId = this.$route.query.contentId
      this.getContent()
    },

    methods: {
      getContent(){
        this.$api.queryContentById(this.contentId).then(res=>{
          // console.log(res);
          if(res.status == 1){
            this.info = res.data
          }else{
            this.$toast(res.message)
          }
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  .a_top{

    padding: 12px 12px 20px;
  }
  .header{
    width: 350px;
    margin: 10px auto 0;
    padding-bottom: 11px;
    border-bottom: 1PX solid #e5e5e5;
    h2{
      font-size: 18px;
    }
    span{
      color: #8c8c8c;
      font-size: 12px;
      display: inline-block;
      width: 125px;
    }
  }
  .f_content{
    ::v-deep img{
      max-width: 100% !important;
      height: auto;
    }
  }
</style>
